import styled from 'styled-components'

import * as NavBarStyles from './NavBarStyles' 

export const LogInButton = styled(NavBarStyles.ActionButton)`
    margin: 0rem 0.35rem;
    cursor: pointer;
`

export const SignUpButton = styled(NavBarStyles.ActionButton)`
    margin: 0rem 0rem;
    cursor: pointer;
`

export const OrItem = styled(NavBarStyles.NavItem)`
    margin: 1.8rem 0.5rem 0rem 0.5rem;
`